import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Roles } from '../../enums/roles';
import { DecodedToken } from '../../models/decoded-token';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  getDecodedToken(token: string): DecodedToken | undefined {
    if (token) {
      const helper = new JwtHelperService();
      const decodedToken = helper.decodeToken(token) as DecodedToken;
      return decodedToken;
    }
    return undefined;
  }

  getCookie(cookieName: string): string | null {
    return (
      document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${cookieName}=`))
        ?.split('=')[1] || null
    );
  }

  getRoleFromToken(): Roles | undefined {
    const accessToken = this.getCookie('accessToken')!;
    // console.log('access token is ', accessToken);

    if (!accessToken) {
      return undefined;
    }

    const decodedToken = this.getDecodedToken(accessToken);
    // console.log(decodedToken);
    
    return decodedToken?.role;
  }

  isEmailVerified(): boolean {
    const accessToken = this.getCookie('accessToken');
    if (!accessToken) {
      return false;
    }

    const decodedToken = this.getDecodedToken(accessToken);
    return !!decodedToken?.emailVerified;
  }
}
